import React, { Component } from 'react';
import { routeActions } from 'react-router-redux';
import {connect} from 'react-redux';
import _ from 'lodash';
import { Row, Col, Icon, Tooltip, Badge } from 'antd';
import { actions as meActions } from 'modules/me';
import { getCollection } from 'modules/collection/actions';
import { toggleClippingPanel } from 'modules/sidebar/actions';
import { Link } from 'react-router';
import Search from './Search';
import clientId from 'clientId';
import classnames from 'classnames';
import {AdvancedSearchLayout} from 'modules/advancedSearch';

import './style.css'

class Header extends Component {

  componentDidMount() {
    const { dispatch, me } = this.props;
    dispatch(getCollection({userId: `${me.id}`}))
  }

  render() {
    const { children, dispatch, clipping, canClipping, permission, isOpen } = this.props;
    const str = _.isEmpty(clipping) ? t('commonClipping') : t('commonClippingCount', {count: clipping.length})
    const host = window.location.host.split('.')[0]

    return (
      <div className={classnames("header", 
        {
          "hkspop-header": clientId == 'hkspop',
          "umac-spop-header": host == "spop-umac",
        })}>
        <div className="pull-right margin-right-lg" style={{marginTop: "28px"}}>
          <Search />
        </div>
        <AdvancedSearchLayout />
      </div>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/components/Component.js
 **/